import * as React from 'react';

import { createIcon } from '../Icon';
export const CornerRightUpIcon = createIcon(
  <React.Fragment>
    <polyline points="10 9 15 4 20 9" />
    <path d="M4 20h7a4 4 0 0 0 4-4V4" />
  </React.Fragment>,
  'CornerRightUpIcon'
);
